module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-bracket-perfetto-168222e13bb3abf4dad66ddc029d1d52.png";